<template>
<div>
  <h1 class="pb-5 has-text-weight-bold is-size-3" style="margin-bottom: -2rem">Challenges</h1>

  <div class="box has-text-centered is-size-4 mt-5" v-if="data !== null && !data.length">
    <b-icon icon="frown" class="mr-2" />
    No Challenges
  </div>
  <div class="columns is-multiline mt-5" v-if="data && data.length">
    <div class="column is-one-quarter" v-for="challenge in data" :key="challenge.name">
      <router-link v-bind:to="'/challenges/' + challenge.name" class="box">
        <nav class="level">
          <div class="level-left">
            <div class="level-item has-text-centered">
              {{ challenge.points }} pts
            </div>
          </div>
          <div class="level-right">
            <div class="level-item has-text-centered">
              {{ challenge.solvers }} solver(s)
            </div>
          </div>
        </nav>
        <div class="challenge-name has-text-centered is-size-3 has-text-weight-bold">
          <b-icon icon="check-circle" v-if="challenge.solved" />
          <b-icon icon="times-circle" v-if="challenge.givenup" />
          <b-icon icon="eye-slash" class="has-text-danger pr-3" v-if="challenge.active === false" />
          {{ challenge.name }}
        </div>
        <div class="challenge-tags tag is-info has-text-link-light is-block pt-1 mt-4 is-medium block is-static has-text-centered">
          {{ challenge.tags }}
        </div>
      </router-link>
    </div>
  </div>

</div>
</template>

<script>
export default {
  data() {
    return {
      data: null,
    };
  },

  async mounted() {
    document.title = 'Challenges';
    const loadingComponent = this.$buefy.loading.open({ container: null });
    try {
      this.data = await this.$ctforge.api.get('/challenges/list');
    } catch (e) {
      this.notify(e.message, 'is-danger');
    }
    loadingComponent.close();
  },
};
</script>

<style>
.challenge-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.challenge-tags {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
